import { CommonService } from './../../../../provide/common.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators, AbstractControl } from '@angular/forms';
import { AuthService } from 'src/app/provide/auth.service';
import { CustomValidators } from 'src/app/provide/Validators';
declare var $;
@Component({
    selector: 'app-signup-service-provider',
    templateUrl: './signup-service-provider.component.html',
    styleUrls: ['./signup-service-provider.component.scss'],
    standalone: false
})
export class SignupServiceProviderComponent implements OnInit {
  @ViewChild('addressInput') addressInputRef: ElementRef<HTMLInputElement>;
  products: any = [];

  signup!: UntypedFormGroup;

  lanlog: any;

  imageUrl: any;
  vertical: any = 'true';
  categoryListArray: any;
  countryCode = new UntypedFormControl('+27');
  country: any = [];
  state: any = [];
  city: any = [];
  isoCode: any;

  // =============for icon 1==========

  visible: boolean = false;
  changetype: boolean = true;

  myToken: any;
  serviceRole: string;

  viewpass() {
    this.visible = !this.visible;
    this.changetype = !this.changetype;
  }

  // 2nd

  visibles: boolean = false;
  changetypes: boolean = true;

  viewpas() {
    this.visibles = !this.visibles;
    this.changetypes = !this.changetypes;
  }
  // myImage: Observable<any> | undefined;
  // title = 'imgtobase64';
  // base64code: any;
  // signUpForm!: FormGroup;
  user: any = {};

  userType: string = '';

  signupTitle: string = 'Signup As Service Provider';
  googleData: any;
  isSocial: boolean = false;
  constructor(
    private http: HttpClient,
    public commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public authService: AuthService
  ) {
    this.googleData = JSON.parse(sessionStorage.getItem('googleApi'));
    if (this.googleData) {
      this.imageUrl = this.googleData.profilePic;
    }
    this.serviceRole = localStorage.getItem('serviceRole');
    if (this.serviceRole == 'PICKUP') {
      this.signupTitle = 'Signup As Pickup Driver';
      this.userType = 'PICKUP_PARTNER';
    } else if (this.serviceRole == 'DELIVERY') {
      this.signupTitle = 'Signup As delivery Partner';
      this.userType = 'DELIVERY_PARTNER';
    } else if (this.serviceRole == 'FIELD') {
      this.signupTitle = 'Signup As Field Entity';
      this.userType = 'FIELD_ENTITY';
    } else {
      this.signupTitle = 'Signup As Service Provider';
      this.userType = 'SERVICE_PROVIDER';
    }
    this.activatedRoute.queryParams.subscribe((ele) => {
      this.isSocial = ele.social;
    });
  }

  ngOnInit(): void {
    this.getCountryList();
    const customValidators = new CustomValidators()
    this.signup = new UntypedFormGroup({
      // image: new FormControl('', [
      //   Validators.required
      // ]),
      fName: new UntypedFormControl(this.googleData ? this.googleData.firstName : '',customValidators.name() ),
      lName: new UntypedFormControl(this.googleData ? this.googleData.lastName : '', customValidators.name()),
      email: new UntypedFormControl(this.googleData ? this.googleData.email : '', customValidators.email()),

      Phone: new UntypedFormControl('', customValidators.phone()),

      countryCode: new UntypedFormControl('+27', [Validators.required]),

      mobileNumber: new UntypedFormControl('', [
        ...customValidators.mobileNumber(),
        Validators.pattern(/^[1-9]\d*$/)
      ]),

      address: new UntypedFormControl('', [Validators.required,...customValidators.address()]),

      locatione: new UntypedFormControl('', customValidators.address()),

      city: new UntypedFormControl('', [
        Validators.required
      ]),

      state: new UntypedFormControl('', [
        Validators.required
      ]),

      zipCode: new UntypedFormControl('', customValidators.zipCode()),

      Country: new UntypedFormControl('', [Validators.required]),

      Password: new UntypedFormControl('', customValidators.password()),
      // Validators.pattern("(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$")]),

      confirmPassword: new UntypedFormControl('', [Validators.required]),

      term: new UntypedFormControl(false, Validators.requiredTrue),
      refferal: new UntypedFormControl('')  // Add the referral code form control
    });
    // this.getSubCategoryListS();
      // Fetching the referral code from URL query parameters
  this.activatedRoute.queryParams.subscribe((params) => {
    const referralCode = params['refferalCode'];  // Extract the referral code
    if (referralCode) {
      this.signup.patchValue({ refferal: referralCode });  // Pre-fill the referral code field
    }
  });

    this.http.get('assets/countrycode.json').subscribe((data: any) => {
      this.products = data.result;
    });
    // this.getListCountry(event);
    if (this.isSocial) {
      this.signup.controls['Password'].clearValidators();
      this.signup.controls['confirmPassword'].clearValidators();
    }
  }
  emailFormatValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (control.value && !emailPattern.test(control.value)) {
      return { 'invalidEmail': true };
    }
    return null;
  }


  NumOnly(event: any) {
    let Numpattern = /^([0-9])*$/;
    let resultNum = Numpattern.test(event.key);
    return resultNum;
  }

  preventLeadingZero(event: KeyboardEvent, controlName: string) {
    if (event.key !== '0') {
      return;
    }
    const control = this.signup?.get(controlName);
    const currentValue = (control?.value || '').toString();
    const input = event.target as HTMLInputElement;
    const caretPosition = input.selectionStart ?? currentValue.length;
    if (!currentValue || caretPosition === 0) {
      event.preventDefault();
    }
  }

  normalizeMobile(controlName: string) {
    const control = this.signup?.get(controlName);
    if (!control) {
      return;
    }
    const value = (control.value || '').toString();
    const normalized = value.replace(/^0+/, '');
    if (normalized !== value) {
      control.setValue(normalized, { emitEvent: false });
    }
  }

  preventSpace(event: any) {
    if (event.charCode == 32 && !event.target.value) {
      event.preventDefault();
    }
  }

  address: any;
  options: any = [];
  longitude: any;
  latitude: any;
  // is_addressInValid: boolean = true
  completedAddress_country: boolean = false;
  completedAddress_state: boolean = false;
  completedAddress_city: boolean = false;
  completedAddress_zip: boolean = false;
  public handleAddressChange(address: any) {
    if ('formatted_address' in address) {
      this.options = [];
      // this.is_addressInValid = false

      this.address = address.formatted_address;

      this.longitude = address.geometry.location.lng();
      this.latitude = address.geometry.location.lat();
      this.options[0] = Number(address.geometry.location.lng());
      this.options[1] = Number(address.geometry.location.lat());

      let country = address.address_components.find((res: any) => {
        return res.types.includes('country');
      });
      let state = address.address_components.find((res: any) => {
        return res.types.includes('administrative_area_level_1');
      });
      let city = address.address_components.find((res: any) => {
        return res.types.includes('locality');
      });
      let zip = address.address_components.find((res: any) => {
        return res.types.includes('postal_code');
      });

      if (country) {
        this.completedAddress_country = true;
        this.signup.patchValue({
          Country: country.long_name,
        });
        this.setZipCode()
      }
      if (state) {
        this.completedAddress_state = true;
        this.signup.patchValue({
          state: state.long_name,
        });
      }

      if (city) {
        this.completedAddress_city = true;
        this.signup.patchValue({
          city: city.long_name,
        });
      }
      if (zip) {
        this.completedAddress_zip = true;
        this.signup.patchValue({
          zipCode: zip.long_name,
        });
      }
    }
    // else {
    //   this.is_addressInValid = true

    // }
  }

  getCountryCode(e: string) {}
  getCirtyISO(e: any) {}
  isSubmitted = false;

  async signUp() {
    // Read the currently visible input value as a source of truth
    const visibleAddress = this.addressInputRef?.nativeElement?.value?.trim();
    if (visibleAddress) {
      this.signup.patchValue({ address: visibleAddress });
      this.address = visibleAddress;
    }
    // if (this.loading) return; // Prevent double submission
    // this.loading = true;      // Set loading immediately
    const controls = this.signup.controls;
    for (const name in controls) {
      console.log(name);
      
      if (controls[name].value && typeof controls[name].value === 'string' && name != 'address') {
        controls[name].setValue(controls[name].value.trim());
      }
    }
    // debugger
    if (this.signup.invalid) {
      this.loading = false;
      this.isSubmitted = true;
      this.commonService.errorToast('Please fill all required field.');
      return;
    }
    if (this.signup.value.Password != this.signup.value.confirmPassword) {
      this.loading = false;
      return this.commonService.errorToast(
        'Password and confirm password must be same.'
      );
    }
    let countryISOCode, stateISOCode;
    if (!this.signup.value.Country.name) {
      countryISOCode = this.country.find((ele) => {
        return (
          String(ele.name).toLowerCase() ==
          String(this.signup.value.Country).toLowerCase()
        );
      });
    }

    if (!this.signup.value.state.name) {
      let stateList = await this.stateList(countryISOCode?.isoCode);
      stateISOCode = stateList.find((ele) => {
        return (
          String(ele.name).toLowerCase() ==
          String(this.signup.value.state).toLowerCase()
        );
      });
    }
    if (!this.latitude || !this.longitude) {
      let response = await this.commonService
        .fetchCordinates(this.address || this.signup.value.address)
        .toPromise();

     let lat = response.result.results[0].geometry.location.lat;
    let lng = response.result.results[0].geometry.location.lng;


      if (isValidLatLng(lat, lng)) {
  this.latitude = lat;
  this.longitude = lng;
} else {
  // fallback - reverse
  this.latitude = lng;
  this.longitude = lat;
}
    }
    var signUpData = {
      firstName: this.signup.value.fName,
      lastName: this.signup.value.lName,
      email: String(this.signup.value.email).toLowerCase(),
      phoneNumber: this.signup.value.Phone,
      mobileNumber: this.signup.value.mobileNumber,
      countryCode: this.signup.value.countryCode,
      addressLine1: this.address || this.signup.value.address,
      addressLine2: this.signup.value.locatione,
      city: this.signup.value.city,
      state: this.signup.value.state.name || this.signup.value.state,
      stateIsoCode: this.signup.value.state.isoCode || stateISOCode.isoCode,

      zipCode: this.signup.value.zipCode,
      // country: this.signup.value.Country,
      country: this.signup.value.Country.name || this.signup.value.Country,
      countryIsoCode:
        this.signup.value.Country.isoCode || countryISOCode.isoCode,
      // countryCode: '+91',
      password: this.signup.value.Password,
      profilePic: this.imageUrl,
      term: this.signup.value.term,
      userType: this.userType,

      storeLocation: {
        type: 'Point',
        coordinates: [this.longitude || 0.0, this.latitude || 0.0],
      },
    };
    if (this.userType != 'SERVICE_PROVIDER') {
      signUpData['pickupFeeArray'] = this.pickupFeeArray;
    }
    this.commonService.showSpinner();
    let url = 'user/signUp';
    if (this.isSocial) {
      url = 'user/signUp?isSocial=true';
    }
    this.commonService.postApi(url, signUpData, 0).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.showSuccessToast(res.responseMessage);
          localStorage.setItem('email', this.signup.value.email);
          this.commonService.hideSpinner();
          // set current url to localstorage

          if (this.isSocial) {
            this.login(res.result);
          } else {
            this.router.navigate(['/login-service-provider']);
          }
          localStorage.setItem("userDetail", JSON.stringify({
            email : String(this.signup.value.email).toLowerCase(), firstName : this.signup.value.fName, lastName : this.signup.value.lName, phoneNumber : this.signup.value.mobileNumber
          }))
          // this.currentUrl = this.route.url;
          // localStorage.setItem('token', res.result.token)
          // after seting current path to localstorage
          // this.route.navigate(['/auth/otp'])
        }
        this.loading = false;
      },
      // err => {
      //   this.commonService.hideSpinner()
      //   this.commonService.errorToast(err.error['responseMessage'])
      // }

      (err: any) => {
        this.loading = false;
        if (err.responseCode == 409) {
          this.commonService.hideSpinner();
          this.commonService.errorToast(err.responseMessage);
        }
      }
    );
  }

  login(result) {
    localStorage.setItem('userId', result._id);
    localStorage.setItem('email', String(result.email).toLowerCase());
    localStorage.setItem('completeProfile', result.completeProfile);
    localStorage.setItem('userRequestStatus', result.userRequestStatus);
    this.authService.SharingData.next(result.completeProfile);
    this.authService.userRequestStatus.next(result.userRequestStatus);
    this.authService.loggedInUserType.next('SERVICE_PROVIDER');
    localStorage.setItem('userRequestStatus', result.userRequestStatus);
    localStorage.setItem('token-auth', result.token);
    this.router.navigate(['/business-details-service-provider']);
  }
  async stateList(iso: any) {
    let apiReqUrl = `${'user/listState?countryCode=' + iso}`;
    let resp: any = await this.commonService.getApi(apiReqUrl, 1).toPromise();
    return resp.result;
  }
  // =-=-=-==-=-=--------Upload Image Functionality Start Here---------=-=-=-=-==-

  // =-=-=-==-=-=--------Upload Image Functionality Start Here---------=-=-=-=-==-
  uploadImg($event: any): void {
    var selectedFile = $event.target.files[0];
    let me = this;
    if (selectedFile) {
      const reader = new FileReader();

      reader.onload = function () {
        me.imageUrl = reader.result; // Get the Base64 part of the data URL
      };

      // Read the image file as a data URL
      reader.readAsDataURL(selectedFile);
    }
    // this.uploadImageFunc(img);
  }
  uploadImageFunc(img: any) {
    var fb = new FormData();
    fb.append('file', img);
    this.commonService.showSpinner();
    this.commonService.postFormDataApi('user/uploadFile', fb, 0).subscribe(
      (res: any) => {
        this.commonService.hideSpinner();
        if (res.responseCode == '200') {
          this.commonService.successToast(res.responseMessage);
          this.imageUrl = res.result.mediaUrl;
        }
      },
      (err) => {
        this.commonService.errorToast(err['responseMessage']);
        this.commonService.hideSpinner();
      }
    );
  }

  getCountryList() {
    this.commonService.getApi('user/listCountry', 1).subscribe((res: any) => {
      this.country = res.result;
    });
  }
  countryIsoCode: any;
  getStateList(event: any) {
    this.signup.patchValue({
      state: '',
      city: '',
    });
    this.countryIsoCode = this.signup.value.Country.isoCode;
    let apiReqUrl = `${'user/listState?countryCode=' + this.countryIsoCode}`;
    this.commonService.getApi(apiReqUrl, 1).subscribe((res: any) => {
      this.state = res.result;
    });
  }

  getCityList(event: any) {
    this.signup.patchValue({
      city: '',
    });
    let stateIsoCode = this.signup.value.state.isoCode;
    let apiReqUrl = `${
      'user/listCity?countryCode=' +
      this.countryIsoCode +
      '&stateCode=' +
      stateIsoCode
    }`;
    this.commonService.getApi(apiReqUrl, 0).subscribe((res: any) => {
      this.city = res.result;
    });
  }

  openFeeModal() {
    $('#FeeConfigModal').modal('show');
  }

  pickupFeeArray: any;
  feeData(e) {
    console.log(e);
    this.pickupFeeArray = e;
    $('#FeeConfigModal').modal('hide');
  }

  loading = false;

  load() {
    this.loading = true;

    setTimeout(() => {
      this.loading = false;
    }, 60000); // 1 minute
  }
  changePasswordIcon() {
    this.changetype = !this.changetype;
  }
  changePasswordIcon1() {
    this.changetypes = !this.changetypes;
  }
  maxLength = 6
  setContryCode(e, required){
    let find = this.products.find((ele)=>{return ele.phonecode == e.target.value}) 
    if(find){
      this.maxLength = find.phoneLength
   
       
        let mobileControl = this.signup.get('Phone');
      
        required && ( mobileControl = this.signup.get('mobileNumber'));
        let phoneValidation = [ Validators.minLength(3), Validators.pattern(find.phoneRegex)]
        if(required){
          phoneValidation = [Validators.required,...phoneValidation]
        }
        mobileControl.setValidators(phoneValidation);
        mobileControl.updateValueAndValidity();

        
     
      }
      
    
  }
  setZipCode(){
    let e = this.signup.value.Country.name ? this.signup.value.Country.name.toLowerCase() : this.signup.value.Country.toLowerCase()
    let find = this.products.find((ele)=>{return ele.name.toLowerCase() == e}) 
    if(find){
      let zipCodeControl = this.signup.get('zipCode');
      let zipCodeValidation = [Validators.required, Validators.pattern(find.zipCodeRegex)]
          zipCodeControl.setValidators(zipCodeValidation);
          zipCodeControl.updateValueAndValidity();
    }
 
  }
}


function isValidLatLng(lat, lng) {
  return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
}